<template>
  <layout-main-inner title="培训管理">
    <div
      v-if="permission.LVL1"
      slot="action">
      <el-button
        type="info"
        @click="downloadTemplate">
        下载模板
      </el-button>
      <el-button
        type="info"
        @click="groupMgr">
        分组管理
      </el-button>
      <el-dropdown>
        <el-button
          type="primary"
          style="margin-left: 10px">
          新增培训<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="additem(1)">线上</el-dropdown-item>
          <el-dropdown-item @click.native="additem(2)">线下</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-dropdown>
        <el-button
          type="primary"
          style="margin-left: 10px;">
          数据导入<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadTemplate">
            下载模板
          </el-dropdown-item>
          <el-dropdown-item @click.native="uploadtmp">
            批量上传
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-radio-group
          v-model="config.trainingType"
          style="flex: 0 0 120px;"
          @change="handleCurrentChange(1)">
          <!-- <el-radio-button :label="null">全部</el-radio-button> -->
          <el-radio-button :label="1">线上</el-radio-button>
          <el-radio-button :label="2">线下</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="config.videoName"
          style="margin-left: 10px"
          clearable
          placeholder="请输入视频名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          key="1"
          label="培训名称"
          min-width="140"
          prop="videoName"> </el-table-column>
        <el-table-column
          key="2"
          label="类型"
          width="50"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.trainingType | trainingTypeName() }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="config.trainingType === 1"
          key="3"
          label="培训视频封面"
          width="105"
          prop="videoImage">
          <template slot-scope="{ row }">
            <el-image
              style="width: 80px; height: 50px"
              :src="row.videoImage"
              :preview-src-list="[row.videoImage]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          v-if="config.trainingType === 1"
          key="4"
          label="培训视频链接"
          min-width="260"
          prop="videoPlayUrl">
          <template slot-scope="{ row }">
            <el-link
              type="primary"
              style="font-size: 12px"
              :underline="false"
              :href="row.videoPlayUrl"
              target="_blank"
              rel="noopener noreferrer">{{ row.videoPlayUrl }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          key="5"
          label="培训内容"
          min-width="180"
          prop="trainingContent"></el-table-column>
        <el-table-column
          v-if="config.trainingType === 1"
          key="11"
          label="排序优先级"
          width="100"
          prop="sortValue">
          <template
            slot="header"
            slot-scope="{ column}">
            <span>{{ column.label }}</span>
            <el-tooltip
              effect="dark"
              content="数字越小，培训视频的位置越靠前。"
              placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-if="config.trainingType === 1"
          key="6"
          label="分组"
          width="80"
          prop="groupNames"></el-table-column>
        <el-table-column
          key="7"
          label="培训人次"
          width="70"
          :formatter="(row)=> row.trainingRecordCount + '人次'"
          prop="trainingRecordCount"></el-table-column>
        <el-table-column
          key="8"
          label="创建时间"
          width="135"
          prop="createdTime">
          <template slot-scope="{ row }">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="permission.LVL1"
          key="9"
          label="操作"
          fixed="right"
          width="160">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">
              编辑
            </el-button>
            <el-dropdown>
              <el-button
                type="primary"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.trainingType === 1"
                  @click.native="sortValue(row)">
                  优先级设置
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="uploadtmp(row)">
                  导入记录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-video-modal
      ref="video"
      :callback="
        () => {
          getlist();
        }
      " />
    <group-mgr-modal
      ref="group"
      :callback="
        () => {
          getlist();
        }
      " />
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest"
    >
      <i ref="upload"></i>
    </el-upload>
    <sort-value-modal
      ref="sort"
      :callback="
        () => {
          getlist();
        }
      " />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditVideoModal from './busi/edit-video-modal.vue'
import GroupMgrModal from './busi/group-mgr-modal.vue'
import SortValueModal from './busi/sort-value-modal.vue'

export default {
  name: 'TrainingVideo',
  components: { EditVideoModal, GroupMgrModal, SortValueModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      currentId: null,
      config: {
        pageNum: 1,
        pageSize: 10,
        trainingType: 1,
        videoName: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    sortValue(row) {
      console.log(row)
      this.$refs.sort.update({
        trainingVideoId: row.trainingVideoId,
        videoName: row.videoName,
        sortValue: row.sortValue
      })
    },
    downloadTemplate() {
      this.loading = true
      this.$store.dispatch('account/downloadtrainingrecordtemplate', {
        payload: {},
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('trainingVideoId', this.currentId)
      this.loading = true
      this.$store.dispatch('account/uploadtrainingrecord', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.getlist()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    uploadtmp(row) {
      this.currentId = row.trainingVideoId
      this.$refs.upload.click()
    },
    groupMgr() {
      this.$refs.group.fetch()
    },
    additem(trainingType) {
      this.$refs.video.add(trainingType)
    },
    updateitem(row) {
      const { trainingVideoId, videoName, videoImage, videoPlayUrl, trainingType, trainingContent } = row
      this.$refs.video.update({
        trainingVideoId,
        videoName,
        trainingType,
        trainingContent,
        videoImage: videoImage.split(',').map(url => ({ url })),
        videoPlayUrl
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/gettrainingvideos', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteitem(row) {
      this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletetrainingvideo', {
          payload: {
            trainingVideoId: row.trainingVideoId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    }
  }
}
</script>
